export default {
	UPDATE_ASSISTANTS: "UPDATE_ASSISTANTS",
	UPDATE_ASSISTANT: "UPDATE_ASSISTANT"
};
